import { render, staticRenderFns } from "./ProductDirectoryEntityProxy.vue?vue&type=template&id=bf875cc8&"
import script from "./ProductDirectoryEntityProxy.vue?vue&type=script&lang=ts&"
export * from "./ProductDirectoryEntityProxy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports